// Vendors
import React from 'react';
import { connectHitInsights, Hits } from 'react-instantsearch-dom';

// Components
import { ClearSearch } from '..';

// Helpers
import { truncateString } from '../../../../lib/utilities';

const ResourceHit = ({ hit, insights }) => {
  const {
    objectID,
    url,
    __queryID,
    __position,
    image,
    label,
    title,
    sku,
    on_sale,
    recently_added,
    short_description,
    regular_price,
    sale_price = undefined
  } = hit || {};

  return (
    <article
      key={objectID}
      data-object-id={objectID}
      data-query-id={__queryID}
      data-object-position={__position}
      className="card product-card"
    >
      <a href={`${url}?queryID=${__queryID}`} className="product-card-image">
        <img src={image} className="card__media" alt={label} />
      </a>
      {/* {on_sale && <span className="card__flag">On Sale</span>}
      {!on_sale && recently_added && <span className="card__flag">New</span>} */}
      <section className="product-card-content">
        <h3>
          <a href={`${url}?queryID=${__queryID}`}>{title}</a>
        </h3>
        <p className="product-sku">Item# {sku}</p>
        <p className="price">${regular_price}</p>
        <a
          href={`${url}?queryID=${__queryID}`}
          className="order-button btn btn--outline"
        >
          Order
        </a>
      </section>
    </article>
  );
};

const HitWithInsights = connectHitInsights(window.aa)(ResourceHit);

const ProductHits = ({ loading = false }) => {
  return (
    <div
      id="product-catalog-hits"
      className={`product-catalog-hits u--margin-top-20 product-catalog-hits__${
        loading ? 'loading' : ''
      }`}
    >
      <Hits hitComponent={HitWithInsights} />
    </div>
  );
};

export default ProductHits;
